import React from "react";
import { Layout } from "antd";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../Error";

const withLayout = (Component) => () => {
  return (
    <Layout>
      <Layout>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Component />
        </ErrorBoundary>
      </Layout>
    </Layout>
  );
};

export default withLayout;
